import React from 'react';
import { PhoneInputLayoutProps, PhoneInputLayoutType } from 'framework/form';
import Box from '@mui/material/Box';

const PhoneInputLayout: PhoneInputLayoutType = ({
  phoneInput,
  extensionInput,
  hasExtension = false,
}: PhoneInputLayoutProps) => {
  return (
    <>
      <Box sx={hasExtension ? { display: 'inline-block', width: '65%', verticalAlign: 'top' } : { width: '100%' }}>
        {phoneInput}
      </Box>

      {hasExtension && (
        <Box sx={{ display: 'inline-block', width: 'calc(35% - 16px)', ml: '16px' }}>{extensionInput}</Box>
      )}
    </>
  );
};

export default PhoneInputLayout;
